<div class="container">
    <div class="ocean" *ngIf="!isMobile; else mobileLayout;">
        <div class="primary-wave" *ngFor="let wave of waves; let i = index" [style.bottom.px]="-198 + (i * 4)"
            [style.animation-delay.s]="-i * 0.1" [style.opacity]="1 - (i / waves.length)"
            [class.inverted]="i % 2 === 1"></div>
        <div class="white-wave" *ngFor="let wave of waves; let i = index" [style.bottom.px]="-298 + (i * 4)"
            [style.animation-delay.s]="-i * 0.1" [style.opacity]="1 - (i / waves.length)"
            [class.inverted]="i % 2 === 1"></div>
    </div>

    <ng-template #mobileLayout>
        <div class="mobile-background">

        </div>
    </ng-template>
</div>